var uploadBoxes;

Vendd.Scripts.load(function () {

    updateUploadBoxes();

});

function updateUploadBoxes() {
    uploadBoxes = new Array();
    $('.x-control.x-upload-box').each(function (index, ub) {
        var $ub = $(ub);
        $ub.id = ub.id;

        var uploadForm = $('*[data-form]', $($ub));

        $ub.supportedTypes = new Array();

        var typ = $ub.data('file-types');

        if (typ.length > 0)
            $ub.supportedTypes = typ.split(',');
        else
            $ub.supportedTypes = new Array();

        $ub.serviceUrl = $ub.data('serviceurl');

        $ub.initCallback = function (box) {};
        $ub.successCallback = function (box) {};
        $ub.failureCallback = function (box) {};
        $ub.cancelCallback = function (box) {};
        $ub.progressCallback = function (box, percentage) {};

        $ub.input = $('*[data-input]', $($ub));
        $ub.remove = $('*[data-remove-button]', $($ub));

        $ub.isFileSelected = function () {
            if ($ub.input.val().length < 1) {
                return false;
            }
            return true;
        };

        $ub.isValid = function () {

            if (!this.isFileSelected())
                return true;

            var input = $('*[data-input]', $($ub));

            var type = input.val().substr((~-input.val().lastIndexOf(".") >>> 0) + 2).toLowerCase();

            if (this.supportedTypes.length > 0) {
                var found = false;
                for (var i = 0; i < this.supportedTypes.length; i++) {
                    if (this.supportedTypes[i] == type)
                        found = true;
                }
                if (!found) {
                    return false;
                }
            }
            return true;
        };

        $ub.validateSelected = function () {
            var input = $('*[data-input]', $($ub));
            if (input.val().length < 1) {
                $('*[data-no-file-text]', $(this)).show().siblings().hide();
                return false;
            }
            return true;
        };

        $ub.validate = function () {
            $('*[data-upload-message]', $ub).hide();

            if (!this.isFileSelected())
                return true;

            var input = $('*[data-input]', $ub);

            var type = input.val().substr((~-input.val().lastIndexOf(".") >>> 0) + 2).toLowerCase();

            if (this.supportedTypes.length > 0) {
                var found = false;
                for (var i = 0; i < this.supportedTypes.length; i++) {
                    if (this.supportedTypes[i] == type)
                        found = true;
                }
                if (!found) {
                    $('*[data-wrong-type-text]', $(this)).show().siblings().hide();
                    return false;
                }
            }
            return true;
        };

        $ub.remove.click(function () {
            $ub.input.replaceWith($ub.input = $ub.input.clone(true)); // MSIE support 

            $ub.input.get(0).form.reset(); 
            $ub.input.get(0).focus();
            
            $ub.input.change();
            $ub.update();
        });

        uploadForm.ubox = $ub;

        uploadForm.upload = function () {
            var input = $('*[data-input]', $(this));
            var fileName = input.val();
            var mubox = this.ubox;

            if (navigator.userAgent.indexOf('Chrome')) {
                fileName = fileName.replace(/C:\\fakepath\\/i, '');
            }

            $(this).ajaxSubmit({
                iframe:false,
                context: this,
                beforeSubmit: function () {
                    var percentVal = '0%';
                    $('*[data-progress-bar]', $(mubox)).width(percentVal);
                    $('*[data-info-text]', $(mubox)).show().siblings().hide();
                    mubox.initCallback(mubox);
                },
                success: function () {
                    var percentVal = '100%';
                    $('*[data-progress-bar]', $(mubox)).width(percentVal);
                    $('*[data-success-text]', $(mubox)).show().siblings().hide();
                    var token = $('*[data-token]', $(mubox)).val()
                    mubox.successCallback(mubox, token);
                },
                uploadProgress: function (event, position, total, percentComplete) {
                    var percentVal = percentComplete + '%';
                    $('*[data-progress-bar]', $(mubox)).width(percentVal);
                    mubox.progressCallback(mubox, percentComplete);
                },
                error: function (responseText, statusText, xhr, $form) {
                    $('*[data-error-text]', $(mubox)).show().siblings().hide();
                    mubox.failureCallback(mubox);
                },
                url: LhApp.Function.Url.getServiceEndpoint(mubox.serviceUrl),
                dataType: 'json',
                type: 'post'

            });

            return false;
        };

        $ub.submit = function (token) {
            var hiddenInput = $('*[data-token]', $(this));
            hiddenInput.val(token);
            
            if (!this.validateSelected()) {
                return true;
            }
            
            if (!this.validate()) {
                return false;
            }
            var form = uploadForm;
            form.upload();

            return true;
        }
        uploadBoxes.push($ub);

        $('*[data-fake-input]', $ub).click(function () {
            $ub.input.trigger('click');
        });

        $ub.update = function () {
            if ($ub.isFileSelected() && $ub.isValid()) {
                $('*[data-file-name]', $ub).html($ub.input.val().replace(/C:\\fakepath\\/i, ''));
                $('.upload-select', $ub).hide();
                $('.upload-chosen', $ub).show();
            } else {
                $('.upload-chosen', $ub).hide();
                $('.upload-select', $ub).show();
            }
        }
    });
}

function generateVisitorToken() {
    var s = randomString(10,'Aa#');
    var d = new Date();
    var n = d.getTime();
    var token = s + '-' + n;
    return token;
}

function randomString(length, chars) {
    var mask = '';
    if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
    if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (chars.indexOf('#') > -1) mask += '0123456789';
    if (chars.indexOf('!') > -1) mask += '~`!@#$%^&*()_+-={}[]:";\'<>?,./|\\';
    var result = '';
    for (var i = length; i > 0; --i) result += mask[Math.round(Math.random() * (mask.length - 1))];
    return result;
}
